import {createTypes, async} from 'redux-action-creator'

export default createTypes(
  [
    'SET_ORIGINAL',
    'SET_ADDRESS',
    'SET_FLOOR',
    'SET_APARTMENT',
    'SET_POSTAL_CODE',
    'SET_STREET_NUMBER',
    'SET_EDIT_DIALOG_OPEN',
    'SET_ADD_DIALOG_OPEN',
    'SET_REMOVE_DIALOG_OPEN',
    'SET_EMPTY_FIELD_ERROR',
    'EDIT',
    ...async('SAVE_EDIT'),
    'ADD',
    ...async('SAVE_ADD'),
    'REMOVE',
    ...async('SAVE_REMOVE'),
  ],
  'PROFILE/ADDRESSES/',
)



// WEBPACK FOOTER //
// ./src/sections/profile/types/addresses.js